import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type EntityDataObject } from 'models/service';

export const leaveCommunity = async ({ id }: { id: string }) => {
  return apiClient.delete<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.community.leave(id));
};
